import z from 'zod'
import { GeoImageTypeEnum } from '../../domain/enums/GeoImageType.enum'
import { CreateUpdateFarmSchema } from './CreateUpdateFarm.schema'
import { BandTypeEnum } from '../../domain/enums/BandType.enum'

export const UpdateGeoImageSchema = z
	.object({
		id: z.uuid(),
		name: z.string(),
		description: z.string().optional(),
		farm: CreateUpdateFarmSchema,
		acquisitionDate: z.date().max(new Date(), { message: 'Data de aquisição não pode ser futura' }),
		imageType: z.enum(GeoImageTypeEnum),
		bands: z.partialRecord(z.enum(BandTypeEnum), z.string()).optional(),
		image: z.file(),
	})
	.transform((data) => {
		const formData = new FormData()

		formData.append('id', data.id)
		formData.append('nome', data.name)
		if (data.description) {
			formData.append('descricao', data.description)
		}
		formData.append('fazenda_id', data.farm)
		formData.append('data_aquisicao', data.acquisitionDate.toISOString())
		formData.append('tipo_imagem', data.imageType)
		const mappedBands = Object.fromEntries(
			Object.entries(data.bands ?? {}).filter(([, v]) => v !== ''),
		)
		if (Object.keys(mappedBands).length > 0) {
			formData.append('identificadores_bandas', JSON.stringify(mappedBands))
		}
		formData.append('imagem', data.image)

		return formData
	})
